import { Inferer, InfererArray } from './inferer';
import type { parseOptions } from './types';
import type { DataType } from '../types';

/**
 * Typesafe infer and transform data.
 */
export function infer(data: unknown) {
	return new Inferer(data as DataType);
}

export type { Inferer, InfererArray, parseOptions };